import { _ as __wbg_init, a1 as _exports } from './index.js';

const module$1 = new URL("aleo_wasm.wasm", import.meta.url);

                async function init(options) {
                    await __wbg_init({
                        module_or_path: await options.module,
                        memory: options.memory,
                    });
                    return _exports;
                }

export { init, module$1 as module };
//# sourceMappingURL=aleo_wasm_custom.js.map
